import React from 'react';
import TestPageRefactored from '../pages/TestPage';

/**
 * Composant contrôleur qui affiche la page de test originale
 */
const HomepageController: React.FC = () => {
  return <TestPageRefactored />;
};

export default HomepageController;
